import { Partner, PartnerService } from '../../../services';
import usePromise from 'react-promise-suspense';

export default function useGetLegalInsurances(): Partner[] {
  const { legalInsurances } = usePromise(PartnerService.getPartners, []);
  return legalInsurances;
}
